<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {},
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang='scss'>
  #app {
    font-family: 'SourceHanSansCN-Regular';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #333333;
  }

  input, textarea, select, button, span {
    font-family: 'SourceHanSansCN-Regular';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    margin: 0 auto;
    background-color: #F3F5F8;
  }

  .svg-icon {
    width: 10px;
    height: 14px;
  }

  a {
    text-decoration: none;
    color: #333;
  }

  .el-input__inner {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
  }

  .contact-box {
    .el-input__inner,.el-textarea__inner {
      font-size: 16px;
    }
  }

  .el-input__inner::-webkit-input-placeholder {
    color: #91a5b4;
  }

  .el-textarea__inner::-webkit-input-placeholder {
    color: #91a5b4;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue